export default {
	props: [ 'size', 'data', 'aid' ],
	data() {
		return {
			xdid: 0,
			shown: false,
			anid: '',
		}
	},
	computed: {
		did(){
			return "pub-" + Math.random().toString(36).slice(2, 7);
		}
	},
	beforeDestroy() {
		const el = document.querySelector("." + this.did)
		if (el) {
			annonce_observer.unobserve(el);
		}
	},
	mounted: function () {
		var that = this;
		that.$nextTick(function () {
			const el = document.querySelector("." + that.did)
			annonce_observer.observe(el);
		});
		
	},
	template: `
		<div :id="anid" :data-aid="aid" :class="did" ></div>`
}


// WEBPACK FOOTER //
// ./assets/js/components/annonce.js